(function () {
  var ROOT_SELECTOR = '.melbourne-marathon-2026-intro';
  var TARGET_SELECTOR = '.melbourne-marathon-2026-intro__animated';
  var WORD_CLASS = 'melbourne-marathon-2026-intro__word';
  var WORD_INNER_CLASS = 'melbourne-marathon-2026-intro__word-inner';
  var READY_CLASS = 'is-ready';
  var INVIEW_CLASS = 'is-inview';
  var JS_CLASS = 'melbourne-marathon-2026-intro--js';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function wrapTextNode(textNode, getIndex) {
    var text = textNode.textContent;
    if (!text || !/\S/.test(text)) return;

    var frag = document.createDocumentFragment();
    var parts = text.split(/(\s+)/);

    parts.forEach(function (part) {
      if (part === '') return;

      if (/^\s+$/.test(part)) {
        frag.appendChild(document.createTextNode(part));
        return;
      }

      var outer = document.createElement('span');
      outer.className = WORD_CLASS;

      var inner = document.createElement('span');
      inner.className = WORD_INNER_CLASS;
      inner.style.setProperty('--mm2026-word-i', String(getIndex()));
      inner.textContent = part;

      outer.appendChild(inner);
      frag.appendChild(outer);
    });

    textNode.parentNode.replaceChild(frag, textNode);
  }

  function splitElement(el) {
    var index = 0;

    function walk(node) {
      var children = Array.prototype.slice.call(node.childNodes);
      children.forEach(function (child) {
        if (child.nodeType === Node.TEXT_NODE) {
          wrapTextNode(child, function () {
            return index++;
          });
          return;
        }

        if (child.nodeType === Node.ELEMENT_NODE) {
          if (child.tagName === 'BR') return;
          if (child.classList && child.classList.contains(WORD_CLASS)) return;
          walk(child);
        }
      });
    }

    walk(el);
    el.classList.add(READY_CLASS);
  }

  function reveal(el) {
    if (el.classList.contains(INVIEW_CLASS)) return;
    el.classList.add(INVIEW_CLASS);
  }

  function observe(el) {
    if (prefersReducedMotion()) {
      el.classList.add(READY_CLASS, INVIEW_CLASS);
      return;
    }

    splitElement(el);

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              reveal(entry.target);
            });
          });
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.2, rootMargin: '0px 0px -8% 0px' }
    );

    io.observe(el);
  }

  function pushModuleImpression(root) {
    if (!root || root.dataset.mm2026IntroImpression === 'true') return;
    root.dataset.mm2026IntroImpression = 'true';

    var moduleName = root.getAttribute('data-ga4-module') || 'slogan';
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: 'ga4Event',
      event_name: 'module_impression',
      event_parameters: {
        module: moduleName,
      },
    });
  }

  function observeModuleImpression(root) {
    if (!root || root.dataset.mm2026IntroImpressionInit === 'true') return;
    root.dataset.mm2026IntroImpressionInit = 'true';

    if (!('IntersectionObserver' in window)) {
      pushModuleImpression(root);
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          pushModuleImpression(root);
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.2 }
    );

    io.observe(root);
  }

  function init(root) {
    if (!root) return;
    root.classList.add(JS_CLASS);
    root.querySelectorAll(TARGET_SELECTOR).forEach(observe);
    observeModuleImpression(root);
  }

  function boot() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector(ROOT_SELECTOR);
    if (root) init(root);
  });
})();
